var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "720",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "채팅상담 안내문구 설정"
    }
  }), _c('v-data-table', _vm._b({
    ref: "data-table",
    staticClass: "v-sheet--outlined",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "item-key": "_id",
      "items-per-page": -1,
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value,
            item = _ref.item;
          return [_c('span', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value))
            }
          })];
        }
      };
    }), {
      key: "item.title",
      fn: function fn(_ref2) {
        var value = _ref2.value,
          item = _ref2.item;
        return [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', [_c('span', [_vm._v(" " + _vm._s(value) + " ")])]), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "right": "",
            "nudge-right": "23",
            "transition": "fade-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var attrs = _ref3.attrs,
                on = _ref3.on;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "small": "",
                  "color": "info lighten-4"
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-information-slab-circle")])];
            }
          }], null, true)
        }, [_c('div', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_vm._v(" " + _vm._s(item.desc) + " ")])])], 1)], 1)];
      }
    }, {
      key: "item.text",
      fn: function fn(_ref4) {
        var item = _ref4.item,
          index = _ref4.index;
        return [_c('v-textarea', _vm._b({
          staticClass: "vertical-table-input text-caption",
          attrs: {
            "rows": "1",
            "auto-grow": "",
            "clearable": ""
          },
          model: {
            value: _vm.items[index].text,
            callback: function callback($$v) {
              _vm.$set(_vm.items[index], "text", $$v);
            },
            expression: "items[index].text"
          }
        }, 'v-textarea', Object.assign({}, _vm.attrs_input__verticalTable, {
          placeholder: item.placeholder
        }), false))];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('v-divider'), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-spacer'), _c('v-divider', {
          attrs: {
            "vertical": ""
          }
        }), _c('v-btn', _vm._b({
          attrs: {
            "text": "",
            "tile": "",
            "color": "primary",
            "height": "48"
          },
          on: {
            "click": _vm.update
          }
        }, 'v-btn', {
          loading: _vm.loading
        }, false), [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-content-save ")]), _vm._v(" 저장하기 ")], 1)], 1)];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false)), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "light": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }